
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_lm6vo_kw88w_98",
  "resize-side": "awsui_resize-side_lm6vo_kw88w_104",
  "resize-bottom": "awsui_resize-bottom_lm6vo_kw88w_107",
  "with-motion": "awsui_with-motion_lm6vo_kw88w_112",
  "root": "awsui_root_lm6vo_kw88w_127",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_kw88w_134",
  "layout": "awsui_layout_lm6vo_kw88w_139",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_kw88w_145",
  "layout-main": "awsui_layout-main_lm6vo_kw88w_149",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_kw88w_155",
  "unfocusable": "awsui_unfocusable_lm6vo_kw88w_160",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_kw88w_164",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_kw88w_169",
  "content-wrapper": "awsui_content-wrapper_lm6vo_kw88w_173",
  "content-overlapped": "awsui_content-overlapped_lm6vo_kw88w_177",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_kw88w_181"
};
  